export enum Roles {
  Administrator = 0,
  Screen = 1,
  Recipe = 2,
}
